import React, { useCallback, useState } from "react";
import { Button } from "@culturehq/components";
import client from "@culturehq/client";

import { useAsyncAction } from "app/hooks";
import { t } from "app/utils";
import inviteTypes from "constants/inviteTypes";
import { rsvpResponseTypeLabelFrom } from "constants/rsvpResponseTypes";

const InviteButton = ({ entity, event, onRefreshInvitations }) => {
  const [refreshed, setRefreshed] = useState(false);

  const { performing, performed, onTrigger } = useAsyncAction(
    useCallback(
      () => (
        client.createEventInvites({
          eventId: event.id,
          [inviteTypes[entity.type].key]: [entity.id]
        })
      ),
      [entity, event]
    )
  );

  if (performed || entity.rsvp) {
    if (performed && !refreshed) {
      setRefreshed(true);
      onRefreshInvitations();
    }
    return (
      <p className="text-center">
        {rsvpResponseTypeLabelFrom(performed ? "invited" : entity.rsvp.responseType)}
      </p>
    );
  }

  const count = entity.userCount;
  const action = (
    count > 1
      ? t(`Send ${count} Invites`)
      : t("Send Invite")
  );

  return (
    <Button inverted onClick={onTrigger} fillParent disabled={performing}>
      {performing ? "Loading..." : action}
    </Button>
  );
};

export default InviteButton;
